var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 51,
    viewBox: "0 0 38 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0487 6.08026C28.0729 6.85868 27.8781 7.68941 27.7025 8.17214C27.3838 9.04873 26.1087 9.4007 25.511 9.46711H19.0362H11.9637C11.2996 9.4007 9.93157 9.04873 9.77219 8.17214C9.68442 7.68941 9.53865 6.85868 9.57336 6.08026M28.0487 6.08026C28.0178 5.09176 27.6336 4.18762 26.4076 4.18762C24.6544 4.18762 23.4192 4.18762 23.0207 4.18762C22.7219 3.12508 21.4468 1 18.7374 1C16.0279 1 14.8857 3.12508 14.6532 4.18762C14.122 4.18762 12.661 4.18762 11.0672 4.18762C9.95259 4.18762 9.61745 5.09176 9.57336 6.08026M28.0487 6.08026H33.6793C34.2106 6.11347 35.3927 6.33926 35.8708 6.97678C36.4685 7.77369 36.3689 8.79698 36.3689 9.89273C36.3689 10.7693 36.3689 35.0677 36.3689 47.7185C36.2361 48.449 35.6517 49.91 34.3766 49.91C33.1016 49.91 24.2161 49.91 19.9327 49.91C15.1513 49.91 5.15017 49.91 3.39698 49.91C1.64379 49.91 1.07267 48.449 1.00626 47.7185C1.00626 34.968 1.00623 10.5303 1.00623 9.89273C1.00623 9.09582 0.906652 7.8733 1.50433 6.97678C1.98247 6.25957 3.16455 6.08026 3.69582 6.08026H9.57336M7.77995 34.6692H29.7944M7.77995 41.6421H29.7944M8.57686 28.792L13.7567 21.9187L20.3312 28.792L28.9975 18.5319",
    stroke: "#605D62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.57673,
    cy: 28.7919,
    r: 1,
    fill: "#605D62",
    stroke: "#605D62",
    strokeWidth: 1.58607
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7569,
    cy: 22.0182,
    r: 1,
    fill: "#605D62",
    stroke: "#605D62",
    strokeWidth: 1.58607
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3311,
    cy: 28.7919,
    r: 1,
    fill: "#605D62",
    stroke: "#605D62",
    strokeWidth: 1.58607
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.898,
    cy: 18.6313,
    r: 1,
    fill: "#605D62",
    stroke: "#605D62",
    strokeWidth: 1.58607
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.bdcf2fa162f64a41af23b14042da03ca.svg";
export { ForwardRef as ReactComponent };